/*
 * AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
 *
 * This file is generated by `generate-api-methods.mjs` from `src/api/generated.ts` (OpenAPI).
 *
 */

import { pdel, pget, ppatch, ppost, pput } from "./index";
export const postAdonisRecommendation = ppost("/adonis/recommendation");

export const getAdonisRecommendationById = pget("/adonis/recommendation/{id}");

export const getAdonisRecommendations = pget("/adonis/recommendations");

export const getAdonisRecommendationsSessionById = pget("/adonis/recommendations/session/{id}");

export const getAdonisStarterQuestions = pget("/adonis/starter-questions");

export const getAdonisTopRecommendations = pget("/adonis/top-recommendations");

export const getAdonisTopRecommendationsId = pget("/adonis/top-recommendations/id");

export const postAdonisWarm = ppost("/adonis/warm");

export const getAgelessAssessments = pget("/ageless/assessments");

export const getAgelessAssessmentsByAssessmentId = pget("/ageless/assessments/{assessmentId}");

export const getAgelessAssessmentsByAssessmentIdRecommendations = pget(
  "/ageless/assessments/{assessmentId}/recommendations",
);

export const postAgelessAssessmentsDefineForCurrentUser = ppost(
  "/ageless/assessments/define-for-current-user",
);

export const getAgelessCapabilities = pget("/ageless/capabilities");

export const getApp = pget("/app");

export const getAppVersion = pget("/app/version");
export const postAppVersion = ppost("/app/version");

export const getAppointmentsPending = pget("/appointments/pending");

export const getAuthClaims = pget("/auth/claims");

export const postAuthExchangeAdminToken = ppost("/auth/exchange-admin-token");

export const postAuthExists = ppost("/auth/exists");

export const postAuthLogin = ppost("/auth/login");

export const postAuthVerify = ppost("/auth/verify");

export const getBeautifiTransactionsByTransactionId = pget(
  "/beautifi/transactions/{transactionId}",
);

export const postBeautifiWebhook = ppost("/beautifi/webhook");

export const putEmailPreferences = pput("/email-preferences");

export const getEmailPreferencesOneClick = pget("/email-preferences/one-click");
export const postEmailPreferencesOneClick = ppost("/email-preferences/one-click");

export const postEmailPreferencesRetrieve = ppost("/email-preferences/retrieve");

export const postFreePackageGroupsByFreePackageGroupIdRedeem = ppost(
  "/free-package-groups/{freePackageGroupId}/redeem",
);

export const getGiftCards = pget("/gift-cards");

export const getGiftCardsGiftCardShare = pget("/gift-cards/gift-card-share");

export const getGiftCardsPublicUrl = pget("/gift-cards/public-url");

export const getGiftCardsPublicByPlatformIdDiscounts = pget(
  "/gift-cards/public/{platformId}/discounts",
);

export const getGiftCardsPublicByPlatformIdListings = pget(
  "/gift-cards/public/{platformId}/listings",
);

export const getGiftCardsPublicPersonByPersonIdPlatformByPlatformIdDiscounts = pget(
  "/gift-cards/public/person/{personId}/platform/{platformId}/discounts",
);

export const getGiftCardsRedeemed = pget("/gift-cards/redeemed");

export const getGiftCardsSent = pget("/gift-cards/sent");

export const postGiftCardsShare = ppost("/gift-cards/share");

export const postGiftCardsTransfer = ppost("/gift-cards/transfer");

export const getGiftCardsTransferByGiftCardTransferItemId = pget(
  "/gift-cards/transfer/{giftCardTransferItemId}",
);

export const getGiftCardsTransferByGiftCardTransferItemIdAnonymous = pget(
  "/gift-cards/transfer/{giftCardTransferItemId}/anonymous",
);

export const postGiftCardsTransfersByGiftCardTransferItemIdResend = ppost(
  "/gift-cards/transfers/{giftCardTransferItemId}/resend",
);

export const postGiftCardsTransfersByPackageTransferIdLinkToOrderByShopDisplayOrderLineItemId =
  ppost("/gift-cards/transfers/{packageTransferId}/link-to-order/{shopDisplayOrderLineItemId}");

export const postGiftCardsTransfersAcknowledgeByTransferId = ppost(
  "/gift-cards/transfers/acknowledge/{transferId}",
);

export const getGiftCardsTransfersByOrderByOrderId = pget(
  "/gift-cards/transfers/by-order/{orderId}",
);

export const getGiftCardsTransfersNotAcknowledged = pget("/gift-cards/transfers/not-acknowledged");

export const getGiveawaysWeek = pget("/giveaways/week");

export const getIncentivesByPlatformIdPersonByPersonIdUnacknowledged = pget(
  "/incentives/{platformId}/person/{personId}/unacknowledged",
);

export const getIncentivesByPlatformIdReferralAchievementsByPersonId = pget(
  "/incentives/{platformId}/referral-achievements/{personId}",
);

export const getIncentivesByPlatformIdReferralHistoryByPersonId = pget(
  "/incentives/{platformId}/referral-history/{personId}",
);

export const getIncentivesByPlatformIdReferralRewardsByPersonIdRedeemable = pget(
  "/incentives/{platformId}/referral-rewards/{personId}/redeemable",
);

export const postIncentivesByPlatformIdReferralByReferralRewardIdAcknowledgeByPersonIdByAwardedReferralRewardId =
  ppost(
    "/incentives/{platformId}/referral/{referralRewardId}/acknowledge/{personId}/{awardedReferralRewardId}",
  );

export const getIncentivesByPlatformLocationIdActiveRewards = pget(
  "/incentives/{platformLocationId}/active-rewards",
);

export const getIncentivesByPlatformLocationIdActiveSignupReward = pget(
  "/incentives/{platformLocationId}/active-signup-reward",
);

export const getIncentivesByPlatformLocationIdActiveSignupRewardAnonymous = pget(
  "/incentives/{platformLocationId}/active-signup-reward/anonymous",
);

export const getIncentivesByPlatformLocationIdAvailableReferralReward = pget(
  "/incentives/{platformLocationId}/available-referral-reward",
);

export const postIncentivesByPlatformLocationIdReferUser = ppost(
  "/incentives/{platformLocationId}/refer-user",
);

export const postIncentivesNudgePersonToSignupForReferralProgram = ppost(
  "/incentives/nudge-person-to-signup-for-referral-program",
);

export const postIncentivesRecordReferralLinkClicked = ppost(
  "/incentives/record-referral-link-clicked",
);

export const postIncentivesRecordReferralPurchaseCompleted = ppost(
  "/incentives/record-referral-purchase-completed",
);

export const postIncentivesRecordReferralSignupCompleted = ppost(
  "/incentives/record-referral-signup-completed",
);

export const postIncentivesRecordReferralSignupStarted = ppost(
  "/incentives/record-referral-signup-started",
);

export const postIncentivesRecordReferralVisitCompleted = ppost(
  "/incentives/record-referral-visit-completed",
);

export const getLinkInBio = pget("/link-in-bio");

export const postLinkInBioInteractions = ppost("/link-in-bio/interactions");

export const getListings = pget("/listings");

export const getListingsById = pget("/listings/{id}");

export const getListingsByIdBeforeAfters = pget("/listings/{id}/before-afters");

export const getListingsByIdExpectations = pget("/listings/{id}/expectations");

export const getListingsByIdLocationAvailability = pget("/listings/{id}/location-availability");

export const getListingsByIdMedia = pget("/listings/{id}/media");

export const getListingsByIdPackages = pget("/listings/{id}/packages");

export const getListingsByIdRelated = pget("/listings/{id}/related");

export const postListingsBasicRecommended = ppost("/listings/basic-recommended");

export const getListingsPublic = pget("/listings/public");

export const getMemberships = pget("/memberships");

export const getMembershipsByMembershipId = pget("/memberships/{membershipId}");

export const getMembershipsByMembershipIdLocationAvailability = pget(
  "/memberships/{membershipId}/location-availability",
);

export const getMembershipsByMembershipIdRewards = pget("/memberships/{membershipId}/rewards");

export const getMembershipsDiscountPrices = pget("/memberships/discount-prices");

export const getMetaImage = pget("/meta/image");

export const postMultiPlatformAuthExists = ppost("/multi-platform/auth/exists");

export const postMultiPlatformAuthVerify = ppost("/multi-platform/auth/verify");

export const getMultiPlatformList = pget("/multi-platform/list");

export const getMultiPlatformLocations = pget("/multi-platform/locations");

export const getMultiPlatformPlatformByPlatformIdLocationCoordinates = pget(
  "/multi-platform/platform/{platformId}/location-coordinates",
);

export const getMultiPlatformPlatformByPlatformIdLocations = pget(
  "/multi-platform/platform/{platformId}/locations",
);

export const getMultiPlatformPlatformByPlatformIdPatientAppHost = pget(
  "/multi-platform/platform/{platformId}/patient-app-host",
);

export const getMultiPlatformPlatformByPlatformIdTheme = pget(
  "/multi-platform/platform/{platformId}/theme",
);

export const getMultiPlatformPlatformDomain = pget("/multi-platform/platform/domain");

export const getMultiPlatformPlatformDomainId = pget("/multi-platform/platform/domain/id");

export const getMultiPlatformPlatformQrcode = pget("/multi-platform/platform/qrcode");

export const postMultiPlatformUser = ppost("/multi-platform/user");

export const getOffers = pget("/offers");

export const getOrdersByShopDisplayOrderId = pget("/orders/{shopDisplayOrderId}");

export const getOrdersByShopDisplayOrderIdReceipt = pget("/orders/{shopDisplayOrderId}/receipt");
export const postOrdersByShopDisplayOrderIdReceipt = ppost("/orders/{shopDisplayOrderId}/receipt");

export const postOrdersByShopDisplayOrderIdSetLocation = ppost(
  "/orders/{shopDisplayOrderId}/set-location",
);

export const postOrdersByShopDisplayOrderIdTransactions = ppost(
  "/orders/{shopDisplayOrderId}/transactions",
);

export const putOrdersByShopDisplayOrderIdTransactionsByShopDisplayOrderTransactionId = pput(
  "/orders/{shopDisplayOrderId}/transactions/{shopDisplayOrderTransactionId}",
);

export const getOrdersBuyNowByOrderIdPayment = pget("/orders/buy-now/{orderId}/payment");
export const postOrdersBuyNowByOrderIdPayment = ppost("/orders/buy-now/{orderId}/payment");

export const postOrdersBuyNowByOrderIdPrepare = ppost("/orders/buy-now/{orderId}/prepare");

export const putOrdersBuyNowByOrderIdTip = pput("/orders/buy-now/{orderId}/tip");

export const getOrdersCurrentAvailablePromos = pget("/orders/current/available-promos");

export const getOrdersCurrentBeautifiCheckoutOptions = pget(
  "/orders/current/beautifi/checkout-options",
);

export const postOrdersCurrentBeautifiInitiate = ppost("/orders/current/beautifi/initiate");

export const getOrdersCurrentDetails = pget("/orders/current/details");

export const getOrdersCurrentDiscountsByDiscountIdEqualOrLesserRewardOptions = pget(
  "/orders/current/discounts/{discountId}/equalOrLesserRewardOptions",
);

export const getOrdersCurrentLineitems = pget("/orders/current/lineitems");
export const postOrdersCurrentLineitems = ppost("/orders/current/lineitems");

export const deleteOrdersCurrentLineitemsByShopDisplayOrderLineItemId = pdel(
  "/orders/current/lineitems/{shopDisplayOrderLineItemId}",
);
export const putOrdersCurrentLineitemsByShopDisplayOrderLineItemId = pput(
  "/orders/current/lineitems/{shopDisplayOrderLineItemId}",
);

export const getOrdersCurrentMembershipDetails = pget("/orders/current/membership/details");

export const postOrdersCurrentPromoCode = ppost("/orders/current/promoCode");

export const deleteOrdersCurrentPromoCodeByPromoCodeId = pdel(
  "/orders/current/promoCode/{promoCodeId}",
);

export const putOrdersCurrentRepeatCash = pput("/orders/current/repeatCash");

export const deleteOrdersCurrentSalesAssociate = pdel("/orders/current/sales-associate");
export const postOrdersCurrentSalesAssociate = ppost("/orders/current/sales-associate");

export const postOrdersCurrentShippingAddress = ppost("/orders/current/shipping-address");

export const getOrdersCurrentSummary = pget("/orders/current/summary");

export const putOrdersCurrentTip = pput("/orders/current/tip");

export const postOrdersCurrentTransactionsByTransactionIdPrepare = ppost(
  "/orders/current/transactions/{transactionId}/prepare",
);

export const postOrdersCurrentTransactionsByTransactionIdUnprepare = ppost(
  "/orders/current/transactions/{transactionId}/unprepare",
);

export const getOrdersLastShippingAddress = pget("/orders/last-shipping-address");

export const getOrdersTransactionByShopDisplayOrderTransactionId = pget(
  "/orders/transaction/{shopDisplayOrderTransactionId}",
);

export const postOrdersTransactionsByTransactionIdCustomerSession = ppost(
  "/orders/transactions/{transactionId}/customer-session",
);

export const getPackagesByPackageId = pget("/packages/{packageId}");

export const postPartnerEmrAppointmentsAvailableTimes = ppost(
  "/partner-emr/appointments/available-times",
);

export const getPartnerEmrTherapists = pget("/partner-emr/therapists");

export const getPaymentMethods = pget("/payment-methods");
export const postPaymentMethods = ppost("/payment-methods");
export const putPaymentMethods = pput("/payment-methods");

export const deletePaymentMethodsByPaymentMethodId = pdel("/payment-methods/{paymentMethodId}");
export const getPaymentMethodsByPaymentMethodId = pget("/payment-methods/{paymentMethodId}");

export const postPaymentMethodsDefaultByPaymentMethodId = ppost(
  "/payment-methods/default/{paymentMethodId}",
);

export const getPlatform = pget("/platform");

export const getPlatformLocation = pget("/platform-location");

export const getPlatformLocationByLocationId = pget("/platform-location/{locationId}");

export const postPlatformLocationByLocationIdBook = ppost("/platform-location/{locationId}/book");

export const postPlatformLocationByLocationIdBookByAppointmentIdConfirm = ppost(
  "/platform-location/{locationId}/book/{appointmentId}/confirm",
);

export const postPlatformLocationByLocationIdBookingSync = ppost(
  "/platform-location/{locationId}/booking/sync",
);

export const getPlatformLocationByLocationIdConcerns = pget(
  "/platform-location/{locationId}/concerns",
);

export const getPlatformLocationByLocationIdPendingAppointments = pget(
  "/platform-location/{locationId}/pending-appointments",
);

export const getPlatformLocationByLocationIdProviderAvailability = pget(
  "/platform-location/{locationId}/provider-availability",
);

export const getPlatformLocationByLocationIdProviderServices = pget(
  "/platform-location/{locationId}/provider-services",
);

export const getPlatformLocationByLocationIdProvidersByServiceByPackageId = pget(
  "/platform-location/{locationId}/providers/by-service/{packageId}",
);

export const getPlatformLocationCoordinates = pget("/platform-location/coordinates");

export const postPlatformLocationPopulateCoordinates = ppost(
  "/platform-location/populate-coordinates",
);

export const getPlatformLocationSalesAssociates = pget("/platform-location/sales-associates");

export const getPlatformUserMemberships = pget("/platform-user-memberships");

export const putPlatformUserMembershipsByPlatformUserMembershipIdCancelMembership = pput(
  "/platform-user-memberships/{platformUserMembershipId}/cancel-membership",
);

export const deletePlatformUserMembershipsByPlatformUserMembershipIdChangeMembership = pdel(
  "/platform-user-memberships/{platformUserMembershipId}/change-membership",
);
export const postPlatformUserMembershipsByPlatformUserMembershipIdChangeMembership = ppost(
  "/platform-user-memberships/{platformUserMembershipId}/change-membership",
);

export const getPlatformUserMembershipsByPlatformUserMembershipIdChangeOptions = pget(
  "/platform-user-memberships/{platformUserMembershipId}/change-options",
);

export const postPlatformUserMembershipsByPlatformUserMembershipIdCreateStripeUpdateSession = ppost(
  "/platform-user-memberships/{platformUserMembershipId}/create-stripe-update-session",
);

export const getPlatformUserMembershipsByPlatformUserMembershipIdFreeze = pget(
  "/platform-user-memberships/{platformUserMembershipId}/freeze",
);

export const postPlatformUserMembershipsByPlatformUserMembershipIdFreezeRequests = ppost(
  "/platform-user-memberships/{platformUserMembershipId}/freeze-requests",
);

export const deletePlatformUserMembershipsByPlatformUserMembershipIdFreezeRequestsByMembershipFreezeId =
  pdel(
    "/platform-user-memberships/{platformUserMembershipId}/freeze-requests/{membershipFreezeId}",
  );

export const putPlatformUserMembershipsByPlatformUserMembershipIdFreezeByMembershipFreezeIdResume =
  pput("/platform-user-memberships/{platformUserMembershipId}/freeze/{membershipFreezeId}/resume");

export const putPlatformUserMembershipsByPlatformUserMembershipIdKeepMembership = pput(
  "/platform-user-memberships/{platformUserMembershipId}/keep-membership",
);

export const postPlatformUserMembershipsByPlatformUserMembershipIdReactivate = ppost(
  "/platform-user-memberships/{platformUserMembershipId}/reactivate",
);

export const postPlatformUserMembershipsByPlatformUserMembershipIdRedeemRepeatCash = ppost(
  "/platform-user-memberships/{platformUserMembershipId}/redeem/repeat-cash",
);

export const putPlatformUserMembershipsByPlatformUserMembershipIdRetryMembershipPayment = pput(
  "/platform-user-memberships/{platformUserMembershipId}/retry-membership-payment",
);

export const getPlatformUserMembershipsCancellationReasons = pget(
  "/platform-user-memberships/cancellation-reasons",
);

export const getPlatformUserMembershipsStatus = pget("/platform-user-memberships/status");

export const postPlatformUserPackageItemsRedeem = ppost("/platform-user-package-items/redeem");

export const postPlatformUserPackageItemsRedeemInApp = ppost(
  "/platform-user-package-items/redeem-in-app",
);

export const getPlatformUserPackages = pget("/platform-user-packages");

export const getPlatformUserPackagesByPackageId = pget("/platform-user-packages/{packageId}");

export const postPlatformUserPackagesByPlatformUserMembershipId = ppost(
  "/platform-user-packages/{platformUserMembershipId}",
);

export const getPlatformByPlatformId = pget("/platform/{platformId}");

export const getPlatformCurrent = pget("/platform/current");

export const getPlatformLocations = pget("/platform/locations");

export const getPlatformTheme = pget("/platform/theme");

export const getPromoCodesByPromoCodeId = pget("/promoCodes/{promoCodeId}");

export const getPromotions = pget("/promotions");

export const getPromotionsByPromotionId = pget("/promotions/{promotionId}");

export const getPromotionsByPromotionIdInclusions = pget("/promotions/{promotionId}/inclusions");

export const postPromotionsByPromotionIdRedeem = ppost("/promotions/{promotionId}/redeem");

export const getPromotionsActiveBanners = pget("/promotions/active-banners");

export const getPromotionsActivePopups = pget("/promotions/active-popups");

export const postPromotionsRedeemInStore = ppost("/promotions/redeem-in-store");

export const getPublicPlatformsByPlatformIdContactCard = pget(
  "/public/platforms/{platformId}/contact-card",
);

export const getReferralCodesByReferralCode = pget("/referral-codes/{referralCode}");

export const getReferralCodesAchievementByPersonIdProgressByPlatformId = pget(
  "/referral-codes/achievement/{personId}/progress/{platformId}",
);

export const getReferralCodesAnonymousStatelessShareUrlByPrettyShareToken = pget(
  "/referral-codes/anonymous/stateless-share-url/{prettyShareToken}",
);

export const postReferralCodesPersonalCodeByPersonId = ppost(
  "/referral-codes/personal-code/{personId}",
);

export const getReferralCodesPersonalCodeByPersonIdShareInvite = pget(
  "/referral-codes/personal-code/{personId}/share-invite",
);

export const postReferralCodesStatelessShareUrlByPersonalReferralCodePlatformByPlatformShareInvite =
  ppost(
    "/referral-codes/stateless-share-url/{personalReferralCode}/platform/{platformShareInvite}",
  );

export const postReferralCodesStatelessShareUrlByPersonIdPlatformByPlatformIdCodeByPrettyShareToken =
  ppost(
    "/referral-codes/stateless-share-url/{personId}/platform/{platformId}/code/{prettyShareToken}",
  );

export const postReferralCodesStatelessShareUrlByPrettyShareTokenRecordClick = ppost(
  "/referral-codes/stateless-share-url/{prettyShareToken}/record/click",
);

export const getReferralCodesStatelessShareUrlByStatelessPrettyToken = pget(
  "/referral-codes/stateless-share-url/{statelessPrettyToken}",
);

export const getReferralCodesTrackedByPersonIdStatelessUrlByPlatformId = pget(
  "/referral-codes/tracked/{personId}/stateless-url/{platformId}",
);

export const getReferralRewardsByPlatformId = pget("/referral-rewards/{platformId}");

export const getReferralRewardsByPlatformIdLocationByLocationId = pget(
  "/referral-rewards/{platformId}/location/{locationId}",
);

export const getReferralRewardsByPlatformIdRepeatCashEarned = pget(
  "/referral-rewards/{platformId}/repeat-cash-earned",
);

export const postReferralRewardsAcknowledgeByPlatformUserRewardId = ppost(
  "/referral-rewards/acknowledge/{platformUserRewardId}",
);

export const getReferralRewardsHistory = pget("/referral-rewards/history");

export const postReferrals = ppost("/referrals");

export const getReferralsUrlByPlatformUserId = pget("/referrals/url/{platformUserId}");

export const getRepeatCashTransactions = pget("/repeat-cash/transactions");

export const getRetailproductsByPlatformIdActiveProductListings = pget(
  "/retailproducts/{platformId}/active-product-listings",
);

export const getRetailproductsByPlatformIdDefaultBrands = pget(
  "/retailproducts/{platformId}/default/brands",
);

export const getRetailproductsByPlatformIdEarned = pget("/retailproducts/{platformId}/earned");

export const postRetailproductsByPlatformIdInitiateSupportByOrderId = ppost(
  "/retailproducts/{platformId}/initiate-support/{orderId}",
);

export const getRetailproductsByPlatformIdOrders = pget("/retailproducts/{platformId}/orders");

export const postRetailproductsByPlatformIdPickup = ppost("/retailproducts/{platformId}/pickup");

export const getRetailproductsByPlatformIdProductListings = pget(
  "/retailproducts/{platformId}/product-listings",
);

export const getRetailproductsByPlatformIdRefundSupportDetailsByOrderId = pget(
  "/retailproducts/{platformId}/refund-support-details/{orderId}",
);

export const getRetailproductsByRetailProductListingIdShopProductListingDetails = pget(
  "/retailproducts/{retailProductListingId}/shop-product-listing-details",
);

export const getRetailproductsAreRetailProductsVisible = pget(
  "/retailproducts/are-retail-products-visible",
);

export const getRetailproductsFaqs = pget("/retailproducts/faqs");

export const getRetailproductsOrdersByOrderId = pget("/retailproducts/orders/{orderId}");

export const getRetailproductsProductTypes = pget("/retailproducts/product-types");

export const postRetailproductsRedeemOrder = ppost("/retailproducts/redeem-order");

export const getRetailproductsStorefrontSettings = pget("/retailproducts/storefront-settings");

export const getRewards = pget("/rewards");

export const getRewardsByRewardId = pget("/rewards/{rewardId}");

export const getRewardsByRewardIdInclusions = pget("/rewards/{rewardId}/inclusions");

export const postRewardsCash = ppost("/rewards/cash");

export const postRewardsRedeem = ppost("/rewards/redeem");

export const postRewardsRedeemInStore = ppost("/rewards/redeem-in-store");

export const getRewardsReferrable = pget("/rewards/referrable");

export const getShop = pget("/shop");

export const getShopCategories = pget("/shop/categories");

export const getShopCustomCategoriesByCategoryIdListings = pget(
  "/shop/custom-categories/{categoryId}/listings",
);

export const getShopCustomCategoriesListings = pget("/shop/custom-categories/listings");

export const getShopDiscounts = pget("/shop/discounts");

export const getShopDiscountsListingsByListingId = pget("/shop/discounts/listings/{listingId}");

export const getShopDisplays = pget("/shop/displays");

export const getShopDisplaysByShopDisplayId = pget("/shop/displays/{shopDisplayId}");

export const getShopDisplaysByShopDisplayIdRelated = pget("/shop/displays/{shopDisplayId}/related");

export const getShopMemberPricing = pget("/shop/member-pricing");

export const getShopMemberships = pget("/shop/memberships");

export const getSkindropIsVisibleOnMarketplace = pget("/skindrop/is-visible-on-marketplace");

export const postSponsorAuthLogin = ppost("/sponsor/auth/login");

export const getSponsorAuthSession = pget("/sponsor/auth/session");

export const postSponsorAuthVerify = ppost("/sponsor/auth/verify");

export const getSponsorSponsors = pget("/sponsor/sponsors");

export const getSponsorSponsorsByPlatformSponsorId = pget("/sponsor/sponsors/{platformSponsorId}");

export const postSponsorSponsorsByPlatformSponsorIdBillingPortalSession = ppost(
  "/sponsor/sponsors/{platformSponsorId}/billing-portal-session",
);

export const getSponsorSponsorsByPlatformSponsorIdMembers = pget(
  "/sponsor/sponsors/{platformSponsorId}/members",
);

export const postSponsorSponsorsByPlatformSponsorIdMembersByPlatformUserMembershipIdFreezeRequests =
  ppost("/sponsor/sponsors/{platformSponsorId}/members/{platformUserMembershipId}/freeze-requests");

export const putSponsorSponsorsByPlatformSponsorIdMembersByPlatformUserMembershipIdUnenroll = pput(
  "/sponsor/sponsors/{platformSponsorId}/members/{platformUserMembershipId}/unenroll",
);

export const getStorefrontMetadata = pget("/storefront/metadata");

export const getStripeKeysPublishableKey = pget("/stripe-keys/publishable-key");

export const postStripeWebhook = ppost("/stripe/webhook");

export const postUploads = ppost("/uploads");

export const deleteUser = pdel("/user");
export const getUser = pget("/user");

export const getUserAddresses = pget("/user-addresses");
export const postUserAddresses = ppost("/user-addresses");
export const putUserAddresses = pput("/user-addresses");

export const deleteUserAddressesByUserAddressId = pdel("/user-addresses/{userAddressId}");

export const getUserCheckIn = pget("/user/check-in");

export const getUserCheckIns = pget("/user/check-ins");

export const getUserExternalTransactions = pget("/user/external-transactions");

export const postUserMarketingConsent = ppost("/user/marketing-consent");

export const getUserOrders = pget("/user/orders");

export const getUserOrdersByShopDisplayOrderId = pget("/user/orders/{shopDisplayOrderId}");

export const putUserPhoneNumber = pput("/user/phone-number");

export const getUserPreferences = pget("/user/preferences");
export const postUserPreferences = ppost("/user/preferences");

export const getUserRewardHistory = pget("/user/reward-history");

export const postUserUpdate = ppost("/user/update");

export const getUserVisits = pget("/user/visits");

export const postVisitCheckin = ppost("/visit/checkin");

export const getVisitCheckinByPlatformLocationId = pget("/visit/checkin/{platformLocationId}");

export const getVisitCount = pget("/visit/count");

export const getWidgets = pget("/widgets");
